import { useEffect } from "react";
import { NuestrosClientesComponents } from "../home/components/NuestrosClientesComponent";

import { useTranslation } from "react-i18next";

import WOW from 'wowjs';

export const ContactenosPage = () => {

    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    return (
        <>
            <section>
                <div className="hero-section position-relative banner-section gap-2">
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento.png" />
                    <h1 className="wow fadeInUp">{t("whereFindUs")}</h1>
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento2.png" />
                </div>
            </section>
            <section className="section px-0">
                <NuestrosClientesComponents />
            </section>
            <section className="section">
                <div class="container">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-md-6">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.0519844993537!2d-74.03186592429043!3d4.760967341130655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f8f61fa80f0c3%3A0x42d59936d03fe964!2sCl.%20183b%20%238-29%2C%20Bogot%C3%A1!5e0!3m2!1ses-419!2sco!4v1757623906469!5m2!1ses-419!2sco"
                                height="450"
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                                className="w-100 shadow-default wow bounceInDown"
                                style={{
                                    borderRadius: "15px"
                                }}
                            ></iframe>
                        </div>
                        <div className="col-md-6">
                            <div className='d-flex flex-column align-items-strat'>
                                <h1 className='title-section mb-2 wow fadeIn'>{t("contactUs")}</h1>
                            </div>
                            <ul className="contact-list mt-4 wow fadeInUp">
                                <li>
                                    <div className="contact-info">
                                        <div className="info-content media-body d-flex">
                                            <img className="me-2" width={30} src={`/assets/img/new/ubicacion.svg`} />
                                            <p className="text">
                                                Calle 183 b # 8 29, Bogota D.C
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="contact-info mt-2 d-flex">
                                        <div className="info-content media-body d-flex">
                                            <img className="me-2" width={30} src={`/assets/img/new/telefono.svg`} />
                                            <p className="text">
                                                (+57) 315 045 9980
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="contact-info mt-2 d-flex">
                                        <div className="info-content media-body d-flex">
                                            <img className="me-2" width={30} src={`/assets/img/new/correo.svg`} />
                                            <p className="text">
                                                <i className="bi bi-facebook"></i> agroesana@gmail.com
                                            </p>
                                        </div>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}